import { useEffect } from 'react'

export const RESIZE_CURSOR = 'col-resize'

/** While dragging, the whole page shows the resize cursor and selects no text, so the cursor doesn't flicker over other elements */
export const useDraggingBodyStyle = (dragging: boolean): void =>
    useEffect(() => {
        if (!dragging) {
            return
        }

        const { cursor, userSelect } = document.body.style
        document.body.style.cursor = RESIZE_CURSOR
        document.body.style.userSelect = 'none'

        return () => {
            document.body.style.cursor = cursor
            document.body.style.userSelect = userSelect
        }
    }, [dragging])
